import React, { useState, useEffect } from "react";
import _, { set } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  getCoachingRequestsList,
  getCoachingRequestsListResponse,
  getCoachingRequestUpdate,
} from "../../../../redux/coaching/actions";
import { SessionKeys } from "../../../../utils/AppUtils";
import { useTranslation } from "react-i18next";
import Page from "../../../Page";
import { useNavigate } from "react-router-dom";
import { Tabs, Tab, Modal } from "react-bootstrap";
import ShimmerForProfileTabs from "../../../Layouts/ShimmerForProfileTabs";
import moment from "moment";
import Loader from "../../../Loader/Loader";
import SlotBookingModal from "./SlotBookingModal";
import BookingCongratsModal from "./BookingCongratsModal";
import Four8HourBookingModal from "./Four8HourBookingModal";

const BookingRequests = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userRole = useSelector((state) => state.user.role);
  const [coachingRequestsData, setCoachingRequestsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [updateLoader, setUpdateLoader] = useState(false);
  const [key, setKey] = useState("all");
  const [sessionModal, setSessionModal] = useState(false);
  const [rescheduleFlag, setRescheduleFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [congratsModal, setCongratsModal] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [selectedCoachId, setSelectedCoachId] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productId, setProductId] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(true);
  const [showModalMsg, setShowModalMsg] = useState(
    "Would you like to unregister from the session?"
  );
  const [showFourHourModal, setShowFourHourModal] = useState(false);
  const [requestedHour, setRequestedHour] = useState(4);
  const [selectedRequest, setSelectedRequest] = useState({});


  const coachingRequestsRes = useSelector(
    (state) => state.coaching.coachingRequestsListData
  );

  const coachingRequestUpdateRes = useSelector(
    (state) => state.coaching.coachingRequestUpdateData
  );

  useEffect(() => {
    coachingRequestAPICall();
    return () => {
      dispatch(getCoachingRequestsListResponse());
    };
  }, [key]);

  const coachingRequestAPICall = () => {
    setIsLoading(true);
    dispatch(
      getCoachingRequestsList({
        module: "coachingRequestsList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: key==="all" ? "" : key==="approved" ? "1" : key==="pending" ? "2" : "3",
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(coachingRequestsRes)) {
      if (coachingRequestsRes?.status === "success") {
        console.log("bookingrequests", coachingRequestsRes);
        let data = coachingRequestsRes?.payload?.payload;
        let userTimezone = userDetailRes?.payload?.payload?.timezoneAbbr;
        for (let request of data) {
          const convertedPreviousStartDate = moment
            .unix(request.prev_start_timestamp)
            .tz(userTimezone);
          const convertedPreviousEndDate = moment
            .unix(request.prev_end_timestamp)
            .tz(userTimezone);
          const convertedProposedStartDate = moment
            .unix(request.proposed_start_timestamp)
            .tz(userTimezone);
          const convertedProposedEndDate = moment
            .unix(request.proposed_end_timestamp)
            .tz(userTimezone);

          const formattedPreviousDate =
            convertedPreviousStartDate.format("Do MMMM, YYYY hh:mmA") +
            " - " +
            convertedPreviousEndDate.format("hh:mmA");
          const formattedProposedDate =
            convertedProposedStartDate.format("Do MMMM, YYYY hh:mmA") +
            " - " +
            convertedProposedEndDate.format("hh:mmA");
          request.formattedPreviousDate = formattedPreviousDate;
          request.formattedProposedDate = formattedProposedDate;

          if (request.request_type === "slot_request" || request.request_type === "slot_reschedule") {
            
            const convertedPreferredDate = moment
            .unix(request.preferred_date)
            .tz(userTimezone);

            const formattedPrerredDate =
            convertedPreferredDate.format("Do MMMM, YYYY")
            request.preferredDate =  request.preferred_date;// formattedPrerredDate;
          }


        }
        setCoachingRequestsData(data);
        setIsLoading(false);
      } else {
        setCoachingRequestsData([]);
        setIsLoading(false);
      }
    }
  }, [coachingRequestsRes]);

  const handleUpdate = (value, id) => {
    if (!_.isEmpty(value)) {
      setUpdateLoader(true);
      dispatch(
        getCoachingRequestUpdate({
          module: "coachingRequestUpdate",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            id: id,
            status: value,
          },
        })
      );
    }
  };

  useEffect(() => {
    if (!_.isEmpty(coachingRequestUpdateRes)) {
      if (coachingRequestUpdateRes?.status === "success") {
        console.log("coachingRequestUpdateRes", coachingRequestUpdateRes);
        setUpdateLoader(false);
        coachingRequestAPICall();
      } else {
        setUpdateLoader(false);
      }
    }
  }, [coachingRequestUpdateRes]);

  const handleClose = () => setShow(false);
  const openSlotModalBooking = () => {
    console.log("SlotModalBooking should open now!");
    setSessionModal(true);
    setRescheduleFlag(true);
    setShow(true);
  };

  const getStatus = (status) => {
    switch (status) {
      case "pending":
        return "Pending";
      case "approved" || "accepted":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "reject_refund":
        return "Rejected & Refund";
      case "reject_new_slot":
        return "Rejected & Propose new date";
      default:
        return "Pending";
    }
  };

  const renderTableReport = () => {
    return (
      <>
        <div className="row my-team-table">
          <div className="col-lg-12 col-md-12">
            <div className="course-info-table">
              {isLoading || coachingRequestsData.length > 0 ? (
                <table className="table mb-0 office_list table-striped">
                  <thead>
                    <tr>
                      <th
                        className={`cursor-pointer is-sort`}
                        onClick={() => { }}
                        style={{ width: "auto" }}
                      >
                        {t("S.No")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort `}
                        onClick={() => { }}
                        style={{ width: "auto" }}
                      >
                        {t("Request")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort `}
                        onClick={() => { }}
                        style={{ width: "auto" }}
                      >
                        {t("Request From")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort `}
                        onClick={() => { }}
                        style={{ width: "auto" }}
                      >
                        {t("Request Date")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort `}
                        onClick={() => { }}
                        style={{ width: "auto" }}
                      >
                        {t("Status")}
                      </th>
                      <th
                        className={`cursor-pointer is-sort `}
                        onClick={() => { }}
                        style={{ width: "auto" }}
                      >
                        {t("Action")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr className="not-found">
                        <td colSpan={6}>
                          {[1, 2, 3, 4, 5].map((m) => {
                            return (
                              <ShimmerForProfileTabs
                                key={`notify-${m}-shimmer`}
                              />
                            );
                          })}
                        </td>
                      </tr>
                    ) : (
                      coachingRequestsData?.map((item, index) => {
                        return (
                          <tr className="addBGcustomw">
                            <td className="itmeeeamil">{index + 1}</td>
                           {item.request_type === "slot_request" ? <td className="itmeeeamil">
                            Request for a {item.hour}-hour session on the preferred date, {item.preferredDate}, in the {item.preferred_time} by {item.request_from_name}.
                          </td> :item.request_type === "slot_reschedule"?  <td className="itmeeeamil">
                          Request to reschedule for a {item.hour}-hour session from {item?.formattedPreviousDate} to preferred date, {item.preferredDate}, in the {item.preferred_time} by {item.request_from_name}.
                        </td>:<td className="itmeeeamil">
                              Request to reschedule session from{" "}
                              {item?.formattedPreviousDate} to{" "}
                              {item?.formattedProposedDate}
                            </td>}
                            <td className="otemrole">
                              {item?.request_from ===
                                localStorage.getItem(SessionKeys.USER_ID)
                                ? "Raised by you"
                                : item?.request_from_name}
                            </td>
                            <td className="officename">
                              {item?.created_at &&
                                moment
                                  .tz(
                                    item?.created_at,
                                    userDetailRes?.payload?.payload
                                      ?.timezoneAbbr
                                  )
                                  .format("D MMM, YYYY")}
                            </td>
                            <td className="itmeeeamil">{getStatus(item?.status)}</td>
                            <td className="itmeeeamil text-center">
                              {(item?.request_from !=
                                localStorage.getItem(SessionKeys.USER_ID) && (item?.request_type === "slot_request" || item.request_type === "slot_reschedule"))? (item.status ==="approved" || item.status ==="rejected")?"-": <>
                                <button className="btn btn-primary" onClick={() => {
                                  setSessionId(item?.id);
                                  setRequestedHour(Number(item?.hour));
                                  setSelectedRequest(item);
                                  setShowFourHourModal(true);
                                }}>{item?.request_type === "slot_request"?"Schedule":"Reschedule"}</button>
                                <button className="btn" onClick={() => {
                                  handleUpdate("rejected", item?.id)
                                }}>Reject</button>
                                </> :item?.request_from !=
                                localStorage.getItem(SessionKeys.USER_ID) &&
                                _.toLower(item?.status) === "pending" ? (
                                <select
                                  className="form-select input_searchfield"
                                  id="category"
                                  aria-label="Default select example"
                                  onChange={(e) => {
                                    if (e.target.value === "reject_new_slot") {
                                      setSelectedCoachId(item?.request_from);
                                      setProductId("");
                                      setConfirmModal(true);
                                      setSessionId(item?.id);
                                      openSlotModalBooking();
                                    } else {
                                      handleUpdate(e.target.value, item?.id)
                                    }
                                  }
                                  }
                                >
                                  <option value="">Select action</option>
                                  <option value="accepted">Accept</option>
                                  <option value={userRole === "provider" ? "rejected" : "reject_new_slot"}>{userRole === "provider" ? "Reject" : "Decline & Propose new date"}</option>
                                  {userRole !== "provider" && <option value="reject_refund">{"Decline & Claim Refund"}</option>}
                                </select>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              ) : (
                <div className="not-found cart-notfound">
                  <div className="interboxes">
                    <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" />
                    <p>{t("Presently there are no requests.")}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <Page>
      <Loader start={updateLoader} />
      <section className="my-credit-points learningpaths">
        <div className="container">
          <div className="row ">
            <div className="col-md-12">
              <button className="mb-4 bck-btn" onClick={() => navigate(-1)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                  fill="none"
                >
                  <path
                    d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                    fill="black"
                  />
                </svg>{" "}
                {t("back")}
              </button>
              <h1 className="lable-heading_search mb-0">
                {t("Booking Requests")}
              </h1>
            </div>
            <div className="contsection video-listing-content mt-4">
              <Tabs
                underline
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                }}
              >
                <Tab eventKey={"all"} title={t("all")}></Tab>
                <Tab eventKey={"approved"} title={t("Approved")}></Tab>

                <Tab eventKey={"pending"} title={t("Pending")}></Tab>

                <Tab eventKey={"rejected"} title={t("Rejected")}></Tab>
              </Tabs>
            </div>
            <div className=" my_learningpath_tab mt-1">
              {renderTableReport()}
            </div>
          </div>
        </div>
      </section>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="custom-modal"
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="coach-detail-sec p-4">
          <div className="de text-center">
            {sessionModal && (
              <SlotBookingModal
                sessionModal={sessionModal}
                setSessionModal={setSessionModal}
                coachId={selectedCoachId}
                setIsLoading={setIsLoading}
                productTitle={productTitle}
                productId={productId}
                displayName={displayName}
                rescheduleFlag={rescheduleFlag}
                onCloseModal={() => setShow(false)}
                setConfirmModal={setConfirmModal}
                setShowModalMsg={setShowModalMsg}
                showCancel={true}
                setShow={setShow}
                setCongratsModal={setCongratsModal}
                sessionId={sessionId}
                is_new_slot={true}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
      <BookingCongratsModal
        show={congratsModal}
        setShow={setCongratsModal}
        slotInfo={""}
        bookingRequestMsg={false}
        showRescheduleMsg={true}
      />
      <Four8HourBookingModal 
        show={showFourHourModal} 
        setShow={setShowFourHourModal}
        getRequestList = {coachingRequestAPICall}
        itemId = {sessionId}
        hour  = {requestedHour}
        selectedRequest = {selectedRequest}
       />
    </Page>
  );
};

export default BookingRequests;
